import React from "react";
import NodePorts from "./NodePorts";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Launch } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #7e57c2 0%, #9575cd 100%)",
    boxShadow: "0 4px 12px rgba(126, 87, 194, 0.4)",
    border: "2px solid #7e57c2",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(126, 87, 194, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 8,
  },
  nodeFooter: {
    fontSize: 11,
    opacity: 0.8,
    marginTop: theme.spacing(0.5),
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #7e57c2",
    borderRadius: "50%",
  },
}));

/**
 * Nodo SALTO A OTRO FLUJO (0419 F1).
 *
 * Solo tiene conector de ENTRADA a propósito: el control pasa al flujo destino y este lienzo
 * termina aquí. Dibujar una salida invitaría a conectar nodos que nunca se ejecutarían.
 */
const JumpToFlowNode = ({ data, selected }) => {
  const classes = useStyles();
  const destino =
    data?.flowName || (data?.flowId ? `Flujo #${data.flowId}` : "Sin flujo destino");

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(126, 87, 194, 0.6)"
          : "0 4px 12px rgba(126, 87, 194, 0.4)",
      }}
    >
      <NodePorts color="#7e57c2" salida={false} />
      <Box className={classes.nodeHeader}>
        <Launch className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Saltar a otro flujo</Typography>
      </Box>
      <Box className={classes.nodeContent}>{destino}</Box>
      <Typography className={classes.nodeFooter}>
        El recorrido continúa en el flujo destino
      </Typography>
    </Box>
  );
};

export default JumpToFlowNode;
